<template>
    <div class="table__responsive">
        <table class="table">
            <thead v-if="!loadingSurveyTemplates && surveyTemplates.length">
                <tr>
                    <th>{{$t('survey_templates.table.header.id')}}</th>
                    <th>{{$t('survey_templates.table.header.title')}}</th>
                    <th>{{$t('survey_templates.table.header.type')}}</th>
                    <th>{{$t('survey_templates.table.header.created_at')}}</th>
                    <th>{{$t('survey_templates.table.header.updated_at')}}</th>
                    <th class="table__cell--icon"></th>
                    <th class="table__cell--icon"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="loadingSurveyTemplates" :key="'loading'" class="table--loading">
                    <td colspan="5">
                        <div class="spinner"></div>
                        <div class="text-center loading_text">{{$t('survey_templates.table.loading')}}</div>
                    </td>
                </tr>
                <tr v-if="!loadingSurveyTemplates && !surveyTemplates.length" :key="'no-survey-templates'" class="table--empty">
                    <td colspan="5">
                        <div class="text-center">{{$t('survey_templates.table.no_survey_templates')}}</div>
                    </td>
                </tr>
                <tr v-if="surveyTemplates.length" v-for="template in surveyTemplates" :key="template.id">
                    <td>{{ template.id }}</td>
                    <td>{{ template.title }}</td>
                    <td>{{ $t('survey_templates.table.types.' + template.type)}}</td>
                    <td>{{ template.created_at }}</td>
                    <td>{{ template.updated_at }}</td>
                    <td><span @click="editTemplate(template)" v-tooltip.right="'Edit'" class="table__icon icons icon-pencil"></span></td>
                    <td><span @click="showDeleteTemplateModal(template)" v-tooltip.bottom="$t('survey_templates.table.delete')" class="table__icon icons icon-trash"></span></td>
                </tr>
                <tr class="table__navigation" v-if="surveyTemplatesMeta && surveyTemplatesMeta.last_page > 1">
                    <td colspan="5">
                        <pagination :meta="surveyTemplatesMeta" @goToPage="goToPage"/>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import Pagination from '@/components/tables/Pagination';
    import { GET_SURVEY_TEMPLATES } from '@/store/modules/survey-templates';

    @Component({
        components: {
            Pagination,
        }
    })
    export default class SurveyTemplatesTable extends Vue {
        name = 'survey-tamplates-table';

        mounted() {
            this.$store.dispatch(GET_SURVEY_TEMPLATES, {});
        }

        get surveyTemplates() {
            return this.$store.state.survey_templates.templates;
        }

        get loadingSurveyTemplates() {
            return this.$store.state.survey_templates.loading;
        }

        get surveyTemplatesMeta() {
            return this.$store.state.survey_templates.templatesMeta;
        }

        goToPage(pageNo) {
            this.$store.dispatch(GET_SURVEY_TEMPLATES, { params: { page: pageNo }});
        }

        editTemplate(template) {
            this.$router.push({ name: 'survey-template', params: { id: template.id }});
        }

        showDeleteTemplateModal(template) {
            const content = {
                title: this.$t('modals.delete_template.title'),
                message: this.$t('modals.delete_template.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteTemplate, template});
        }

        deleteTemplate({template}) {
            template.remove()
                .then(() => {
                    this.$notify.success(this.$t('notify.template.delete_success'));
                    this.$store.dispatch(GET_SURVEY_TEMPLATES, {});
                })
                .catch(err => this.$notify.error(this.$t('notify.template.delete_error')));
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tables/survey-templates/SurveyTemplatesTable.vue